"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardRepository = void 0;
const httpRepository_1 = __importDefault(require("./httpRepository"));
exports.DashboardRepository = {
    getCompanyMetrics: async () => {
        const result = await httpRepository_1.default.tradeshiftGo().get('/rest/dashboard/company');
        return result.data;
    },
    getTeamMetrics: async (teamId) => {
        const result = await httpRepository_1.default.tradeshiftGo().get(`/rest/dashboard/team/${teamId}`);
        return result.data;
    },
    getManagerMetrics: async (teamId) => {
        const result = await httpRepository_1.default.tradeshiftGo().get(`/rest/dashboard/team/${teamId}/manager`);
        return result.data;
    },
    getSettlementsForCompany: async (fromDate, toDate) => {
        const result = await httpRepository_1.default.tradeshiftGo().get(`/rest/payments/settlements/company?from=${fromDate}&to=${toDate}`);
        return result.data;
    },
    getSettlementsForTeam: async (teamId, fromDate, toDate) => {
        const result = await httpRepository_1.default.tradeshiftGo().get(`/rest/payments/settlements/team/${teamId}?from=${fromDate}&to=${toDate}`);
        return result.data;
    },
    getSettlementsForTeamManager: async (teamId, fromDate, toDate) => {
        const result = await httpRepository_1.default.tradeshiftGo().get(`/rest/payments/settlements/team/${teamId}/manager?from=${fromDate}&to=${toDate}`);
        return result.data;
    },
};
